import { DropdownType, FilterOptionsConstantTypes } from './types'
import { FilterOperatorsType } from './types/tableFilterTypes'

export const FORMAT_PATTERN = {
  PHONE_INPUT: 'XXX-XXX-XXXX',
  PHONE_INPUT_2: '(XXX) XXX-XXXX',
  SSN: 'XXX-XX-XXXX',
  ZIP_CODE: 'XXXXX-XXXX',
  LAST_4_DIGIT_SSN: 'XXXX',
}

export const REGEX = {
  PHONE_INPUT: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
  SSN: /^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/,
  LAST_4_DIGIT_SSN: /^\d{4}$/,
  HAS_UPPERCASE_REGEX: /(?=.*[A-Z])/,
  HAS_LOWERCASE_REGEX: /(?=.*[a-z])/,
  HAS_DIGIT_REGEX: /(?=.*\d)/,
  HAS_SPECIAL_CHAR_REGEX: /(?=.*[!@#$%^&*])/,
  HAS_VALID_LENGTH_REGEX: /^[A-Za-z\d!@#$%^&*]{8,14}$/,
  ZIP_CODE: /^\d{5}(?:-\d{4})?$/,
}

export const VALUE_CONSTANTS = {
  ZERO: 0,
  TWO: 2,
  EIGHT: 8,
  TWO_ZERO: 20,
  THIRTY_EIGHT: 38,
  TWO_FOUR_ZERO: 240,
  EIGHTY: 80,
}

export const TABLE_ACTION_TYPE = {
  TOGGLE: 'toggle',
  INVERTED_TOGGLE: 'inverted-toggle',
  COMPONENT: 'component',
  EXPAND: 'expand',
} as const

export const ACTION_ICONS_NAMESPACE = {
  EDIT: 'edit',
  DELETE: 'delete',
  VIEW: 'view',
  CLONE: 'clone',
  REJECT: 'reject',
  APPROVE: 'approve',
  ENTER: 'Enter',
  COMA: ',',
  TAB: 'Tab',
  REQUIRED: 'Required',
  _REQUIRED: 'required',
  STAR: '*',
  REVIEW: 'review',
}

export const columnTypesConst = {
  CHECKBOX: 'checkbox',
  TEXT: 'text',
  HYPERLINK: 'hyperlink',
  TOGGLE_BUTTON: 'toggle',
  IMAGE: 'image',
  COMPONENT: 'component',
  STATUS: 'status',
  RADIO: 'radio',
  MULTI_LINE_TEXT: 'multi-line-text',
  SELECT_BOX: 'select-box',
}

export const widthClasses: {
  [key: string]: string
} = {
  '0': 'max-w-4 min-w-4',
  '1': 'max-w-8 min-w-8',
  '2': 'max-w-[4rem] min-w-[4rem]',
  '3': 'max-w-[6rem] min-w-[6rem]',
  '4': 'max-w-[8rem] min-w-[8rem]',
  '5': 'max-w-[10rem] min-w-[10rem]',
  '6': 'max-w-[12rem] min-w-[12rem]',
  '7': 'max-w-[14rem] min-w-[14rem]',
  '8': 'max-w-[16rem] min-w-[16rem]',
  '9': 'max-w-[18rem] min-w-[18rem]',
  '10': 'max-w-[20rem] min-w-[20rem]',
  '11': 'max-w-[22rem] min-w-[22rem]',
  '12': 'max-w-[24rem] min-w-[24rem]',
  '13': 'max-w-[26rem] min-w-[26rem]',
  '14': 'max-w-[28rem] min-w-[28rem]',
  '15': 'max-w-[30rem] min-w-[30rem]',
  '16': 'max-w-[32rem] min-w-[32rem]',
  '17': 'max-w-[34rem] min-w-[34rem]',
  '18': 'max-w-[36rem] min-w-[36rem]',
  '19': 'max-w-[38rem] min-w-[38rem]',
  '20': 'max-w-[40rem] min-w-[40rem]',
  '21': 'max-w-[42rem] min-w-[42rem]',
  '22': 'max-w-[44rem] min-w-[44rem]',
  '23': 'max-w-[46rem] min-w-[46rem]',
  '24': 'max-w-[48rem] min-w-[48rem]',
  '25': 'max-w-[50rem] min-w-[50rem]',
  '26': 'max-w-[52rem] min-w-[52rem]',
  '27': 'max-w-[54rem] min-w-[54rem]',
  '28': 'max-w-[56rem] min-w-[56rem]',
  '29': 'max-w-[58rem] min-w-[58rem]',
  '30': 'max-w-[60rem] min-w-[60rem]',
  '31': 'max-w-[62rem] min-w-[62rem]',
  '32': 'max-w-[64rem] min-w-[64rem]',
  '33': 'max-w-[66rem] min-w-[66rem]',
  '34': 'max-w-[68rem] min-w-[68rem]',
  '35': 'max-w-[70rem] min-w-[70rem]',
  '36': 'max-w-[72rem] min-w-[72rem]',
  '37': 'max-w-[74rem] min-w-[74rem]',
  '38': 'max-w-[76rem] min-w-[76rem]',
  '39': 'max-w-[78rem] min-w-[78rem]',
  '40': 'max-w-[80rem] min-w-[80rem]',
  auto: 'min-w-auto',
}

export const filterOptionsConstant: FilterOptionsConstantTypes = {
  string: [{ value: 'LIKE', label: 'Contains' }],
  boolean: [{ value: 'EQUALS_BOOLEAN', label: 'Equals' }],
  number: [
    { value: 'EQUALS', label: 'Equals' },
    { value: 'GREATER_THAN', label: 'Greater Than' },
    { value: 'LESS_THAN', label: 'Less Than' },
    { value: 'BETWEEN', label: 'Between' },
  ],
  date: [
    { value: 'BEFORE', label: 'Before' },
    { value: 'AFTER', label: 'After' },
    { value: 'ON', label: 'ON' },
    { value: 'BETWEEN', label: 'Between' },
  ],
}

export const googleAutocompleteInput = {
  GOOGLE_API_SCRIPT: `script[src*="maps.googleapis.com/maps/api/js"]`,
  REQUIRED: 'Required',
}

export const communicationStatus = {
  FAILED: 'Failed',
  COMPLETED: 'Completed',
  SUCCESSFUL: 'Successful',
  SUCCESSFUL_UPPER: 'SUCCESSFUL',
  RECIEVED: 'Received',
  DISCARDED: 'Discarded',
  SUCCESS: 'Success',
  IN_PROGRESS: 'In Progress',
  SPLIT: 'Split',
  FAILED_UPPERCASE: 'FAILED',
  SUCCESS_UPPERCASE: 'SUCCESS',
  RECIEVED_UPPERCASE: 'RECEIVED',
  IN_PROGRESS_UPPERCASE: 'IN_PROGRESS',
  COMPLETED_UPPERCASE: 'COMPLETED',
  DISCARDED_UPPERCASE: 'DISCARDED',
  SPLIT_UPPERCASE: 'SPLIT',
  PENDING_DISPATCH: 'PENDING_DISPATCH',
  PENDING_DISPATCH_UPPERCASE: 'PENDING DISPATCH',
  TRANSMISSION_FAILED: 'TRANSMISSION_FAILED',
  TRANSMISSION_FAILED_UPPERCASE: 'TRANSMISSION FAILED',
  TRANSMISSION_IN_PROGRESS: 'TRANSMISSION_IN_PROGRESS',
  PROCESSING_PRINTING: 'PROCESSING_PRINTING',
  PROCESSING_PRINTING_UPPERCASE: 'PROCESSING PRINTING',
  TRANSMISSION_IN_PROGRESS_UPPERCASE: 'TRANSMISSION IN PROGRESS',
  TRANSMISSION_SUCCESSFUL: 'TRANSMISSION_SUCCESSFUL',
  TRANSMISSION_SUCCESSFUL_UPPERCASE: 'TRANSMISSION SUCCESSFUL',
  FAX_PREVIEW: 'Fax Preview',
  VOIDED: 'Voided',
  VOIDED_UPPERCASE: 'VOIDED',
  VOID_UPPERCASE: 'VOID',
  VOID: 'Void',
  PROCESSING: 'Processing',
  DRAFT: 'Draft',
}

export const booleanValues = {
  TRUE: true,
  FALSE: false,
}

export const Confirmation = {
  YES: 'Yes',
  NO: 'No',
  CANCEL: 'Cancel',
}

export const exportButtons = {
  CSV: 'CSV',
  EXCEL: 'EXCEL',
  PDF: 'PDF',
}

export const EMAIL_REGEX =
  /^[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/
export const US_ZIP_REGEX = /^\d{5}(-?\d{4})?$/
export const HEX_COLOR_REGEX = /^#([0-9A-F]{3}){1,2}$/i

export const tableFilterType = {
  STRING: 'string',
  STRING_DYNAMIC: 'string-dynamic',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  DATE: 'date',
  DATE_TIME: 'date-time',
  DATE_TIME_DYNAMIC: 'date-time-dynamic',
  TIME: 'time',
  DROPDOWN: 'dropdown',
  MULTI_SELECT_DYNAMIC: 'multi-select-dynamic',
} as const

export enum buttonTypeENUM {
  SUBMIT = 'submit',
  BUTTON = 'button',
  RESET = 'reset',
}

export const filterOperatorValues = {
  LIKE: 'LIKE',
  EQUALS: 'EQUALS',
  EQUALS_BOOLEAN: 'EQUALS_BOOLEAN',
  IN: 'IN',
  IS_BEFORE: 'IS_BEFORE',
  IS_BEFORE_OR_EQUAL_TO: 'IS_BEFORE_OR_EQUAL_TO',
  IS_AFTER: 'IS_AFTER',
  IS_AFTER_OR_EQUAL_TO: 'IS_AFTER_OR_EQUAL_TO',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  STARTS_WITH: 'STARTS_WITH',
  ENDS_WITH: 'ENDS_WITH',
  NOT_EQUALS: 'NOT_EQUALS',
  IS_NULL: 'IS_NULL',
  IS_NOT_NULL: 'IS_NOT_NULL',
  BETWEEN: 'BETWEEN',
  NOT_BETWEEN: 'NOT_BETWEEN',
  CONTAINS_LIST: 'CONTAINS_LIST',
  IS_EMPTY_NULL: 'IS_EMPTY_NULL',
  IS_NOT_EMPTY_NOT_NULL: 'IS_NOT_EMPTY_NOT_NULL',
}

export const STRING_FILTER_OPERATORS: FilterOperatorsType[] = [
  { value: filterOperatorValues.CONTAINS, label: 'Contains' },
  { value: filterOperatorValues.DOES_NOT_CONTAIN, label: 'Does Not Contain' },
  { value: filterOperatorValues.EQUALS, label: 'Is Equal To' },
  { value: filterOperatorValues.NOT_EQUALS, label: 'Is Not Equal To' },
  { value: filterOperatorValues.STARTS_WITH, label: 'Starts With' },
  { value: filterOperatorValues.ENDS_WITH, label: 'Ends With' },
  { value: filterOperatorValues.IS_EMPTY_NULL, label: 'Is Null' },
  { value: filterOperatorValues.IS_NOT_EMPTY_NOT_NULL, label: 'Is Not Null' },
]

export const NUMERIC_FILTER_OPERATORS: FilterOperatorsType[] = [
  { value: filterOperatorValues.EQUALS, label: 'Is Equal To' },
  { value: filterOperatorValues.NOT_EQUALS, label: 'Is Not Equal To' },
  { value: filterOperatorValues.GREATER_THAN, label: 'Is Greater Than' },
  {
    value: filterOperatorValues.GREATER_THAN_OR_EQUAL,
    label: 'Is Greater Than or Equal',
  },
  { value: filterOperatorValues.LESS_THAN, label: 'Is Less Than' },
  {
    value: filterOperatorValues.LESS_THAN_OR_EQUAL,
    label: 'Is Less Than or Equal',
  },
  { value: filterOperatorValues.BETWEEN, label: 'Is In Range' },
  { value: filterOperatorValues.NOT_BETWEEN, label: 'Is Not In Range' },
  { value: filterOperatorValues.IS_NULL, label: 'Is Null' },
  { value: filterOperatorValues.IS_NOT_NULL, label: 'Is Not Null' },
]

export const DATE_FILTER_OPERATORS: FilterOperatorsType[] = [
  { value: filterOperatorValues.EQUALS, label: 'Is Equal To' },
  { value: filterOperatorValues.NOT_EQUALS, label: 'Is Not Equal To' },
  { value: filterOperatorValues.IS_BEFORE, label: 'Is Before' },
  {
    value: filterOperatorValues.IS_BEFORE_OR_EQUAL_TO,
    label: 'Is Before or Equal To',
  },
  { value: filterOperatorValues.IS_AFTER, label: 'Is After' },
  {
    value: filterOperatorValues.IS_AFTER_OR_EQUAL_TO,
    label: 'Is After or Equal To',
  },
  { value: filterOperatorValues.BETWEEN, label: 'Is In Range' },
  { value: filterOperatorValues.NOT_BETWEEN, label: 'Is Not In Range' },
  { value: filterOperatorValues.IS_NULL, label: 'Is Null' },
  { value: filterOperatorValues.IS_NOT_NULL, label: 'Is Not Null' },
]

export const DATE_TIME_FILTER_OPERATORS: FilterOperatorsType[] = [
  { value: filterOperatorValues.EQUALS, label: 'Is Equal To' },
  { value: filterOperatorValues.NOT_EQUALS, label: 'Is Not Equal To' },
  { value: filterOperatorValues.IS_BEFORE, label: 'Is Before' },
  {
    value: filterOperatorValues.IS_BEFORE_OR_EQUAL_TO,
    label: 'Is Before or Equal To',
  },
  { value: filterOperatorValues.IS_AFTER, label: 'Is After' },
  {
    value: filterOperatorValues.IS_AFTER_OR_EQUAL_TO,
    label: 'Is After or Equal To',
  },
  { value: filterOperatorValues.BETWEEN, label: 'Is In Range' },
  { value: filterOperatorValues.NOT_BETWEEN, label: 'Is Not In Range' },
  { value: filterOperatorValues.IS_NULL, label: 'Is Null' },
  { value: filterOperatorValues.IS_NOT_NULL, label: 'Is Not Null' },
]

export const TIME_FILTER_OPERATORS: FilterOperatorsType[] = [
  { value: filterOperatorValues.EQUALS, label: 'Is Equal To' },
  { value: filterOperatorValues.NOT_EQUALS, label: 'Is Not Equal To' },
  { value: filterOperatorValues.BETWEEN, label: 'Is In Range' },
  { value: filterOperatorValues.NOT_BETWEEN, label: 'Is Not In Range' },
  { value: filterOperatorValues.IS_NULL, label: 'Is Null' },
  { value: filterOperatorValues.IS_NOT_NULL, label: 'Is Not Null' },
]

export const BOOLEAN_FILTER_OPTIONS: DropdownType<boolean>[] = [
  { value: 'all', label: 'All', search_value: null },
  { value: 'true', label: 'True', search_value: true },
  { value: 'false', label: 'False', search_value: false },
]

export const MULTI_UPLOAD_FILE_TYPE = {
  PDF: 'application/pdf',
  XLS: 'application/vnd.ms-excel',
  TXT: 'text/plain',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  DOCM: 'application/vnd.ms-word.document.macroEnabled.12',
  PPT: 'application/vnd.ms-powerpoint',
  PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  JPG: 'image/jpg',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  DOC: 'application/msword',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLSM: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  CSV: 'text/csv',
  EML: 'message/rfc822',
  SVG: 'image/svg+xml',
} as const

export const FILE_FORMAT_OPTIONS = [
  { label: 'PNG', value: 'png' },
  { label: 'JPG', value: 'jpg' },
  { label: 'PDF', value: 'pdf' },
  { label: 'DOC', value: 'doc' },
  { label: 'DOCX', value: 'docx' },
  { label: 'DOCM', value: 'docm' },
  { label: 'XLS', value: 'xls' },
  { label: 'XLSX', value: 'xlsx' },
  { label: 'XLSM', value: 'xlsm' },
  { label: 'CSV', value: 'csv' },
  { label: 'PPT', value: 'ppt' },
  { label: 'PPTX', value: 'pptx' },
  { label: 'TXT', value: 'txt' },
  { label: 'EML', value: 'eml' },
]

export const FILE_EXTENSIONS = {
  DOC: 'doc',
  DOCX: 'docx',
  DOCM: 'docm',
  XLSX: 'xlsx',
  XLSM: 'xlsm',
  XLS: 'xls',
  CSV: 'csv',
  EML: 'eml',
  PPT: 'ppt',
  PPTX: 'pptx',
} as const

export const FILE_TYPE_TOASTER = {
  FILE_TYPE_NOT_SUPPORTED: 'Preview not available for this file type.',
}

export const MODE_CONSTANTS = {
  ADD: 'add',
  EDIT: 'edit',
  VIEW: 'view',
  HIDDEN: 'hidden',
  VIEW_360: 'view360',
} as const

export const UPLOADING_STATE = {
  FILE_UPLOADING_STATE: 'Uploading...',
  FILE_COMPLETED_STATE: 'Completed',
}

export const FIELD_VALUE_CONSTANTS = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FIVE: 5,
  TEN: 10,
  FIFTEEN: 15,
  SEVEN: 7,
  SIXTEEN: 16,
  TWENTY: 20,
  TWENTY_FIVE: 25,
  FIFTY: 50,
  FIFTY_NINE: 59,
  HUNDRED: 100,
  ONE_HUNDRED_TEN: 110,
  ONE_HUNDRED_SIXTY: 160,
  TWO_HUNDRED: 200,
  TWO_HUNDRED_FIFTY_FIVE: 255,
  TWO_FIFTY_FIVE: 255,
  FIVE_HUNDRED: 500,
  EIGHT_FOUR_TWO: 842,
  TWO_THOUSAND: 2000,
  MAXIMUM_ALLOWED_NUMBER: 2147483647,
}

export const TAB_KEY_CONSTANTS = {
  ARROW_RIGHT: 'ArrowRight',
  ARROW_LEFT: 'ArrowLeft',
  ENTER: 'Enter',
  HOME: 'Home',
  END: 'End',
  _JPG: '.jpg',
  _PDF: '.pdf',
}

export const BOOLEAN_FILTER_OPERATORS: FilterOperatorsType[] = [
  { value: filterOperatorValues.EQUALS_BOOLEAN, label: 'Is Equal To' },
  { value: filterOperatorValues.IS_NULL, label: 'Is Null' },
  { value: filterOperatorValues.IS_NOT_NULL, label: 'Is Not Null' },
]

export const DROPDOWN_FILTER_OPERATORS: FilterOperatorsType[] = [
  { value: filterOperatorValues.IN, label: 'Is Equal To' },
  { value: filterOperatorValues.IS_NULL, label: 'Is Null' },
  { value: filterOperatorValues.IS_NOT_NULL, label: 'Is Not Null' },
]

export enum SORT_KEYS {
  Disabled = 'disabled',
  Asc = 'asc',
  Desc = 'desc',
}

export const POSITION_CONSTANTS = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  OVER: 'over',
  AUTO: 'auto',
  UNSET: 'unset',
} as const

export const sidebarPopupConfig: { url: string[]; message: string }[] = [
  {
    url: [
      'manage-queue/:tenantid/edit-queue/:id',
      'manage-queue/:tenantid/create-queue',
    ],
    message: 'Are you sure you want to discard the changes?',
  },
]

export const DATE_INPUT_CONSTANTS = {
  CLEAR: 'Clear',
  TODAY: 'Today',
  DEFAULT_YEARS_TO_SHOW: 1100, //3000-1900 +1
  MAX_DATE: '3000-12-31',
  MIN_DATE: '1900-01-01',
  COMMON_DATE_FORMAT: 'MM/DD/YYYY',
  DATE_FORMAT_API: 'YYYY-MM-DD',
  COMMON_DATE_FORMAT_FOR_DATE_INPUT: 'MM/dd/yyyy',
  COMMON_DATE_FORMAT_FOR_DATE_TIME_INPUT: 'MM/dd/yyyy HH:mm',
  COMMON_DATE_TIME_FORMAT: 'MM/DD/YYYY HH:mm z',
  COMMON_DATE_TIME_FORMAT_2: 'MM/DD/YYYY HH:mm',
  SUPPOERTED_DATE_TIME_FORMAT_DATE_TIME_INPUT_FIELD: 'MM/dd/yyyy HH:mm z',
}
export enum DATE_FIELD_TYPES {
  DATE_TYPE = 'date',
  DATE_TIME_LOCAL = 'datetime-local',
}

export enum FileType {
  PDF = 'pdf',
  WORD = 'word',
  EXCEL = 'excel',
  IMAGE = 'image',
  OTHER = 'other',
}

export const HTML_TYPE = {
  UNKNOWN: 'unknown',
  BASE64_PDF: 'base64-pdf',
  HTML: 'html',
  PDF: 'pdf',
  DOCX: 'docx',
  URL_PDF: 'url-pdf',
  URL_DOCX: 'url-docx',
  HTML_UPPERCASE: 'HTML',
  DOCX_UPPPERCASE: 'DOCX',
}

export const NAMESPACES = {
  LOADING: 'Loading...',
}

export const TENANTS = {
  TEVA_CARES: 4252,
  TEVA: 3607,
  NOVO: 1003,
} as const

export const DASHBOARD_CHART_COLOR = {
  OVERDUE_COLOR: '#E57373',
  AT_RISK_COLOR: '#F4D06F',
  ON_TRACK_COLOR: '#81C784',
  PAUSED_MI_COLOR: '#90CAF9',
}

export const NUMERIC_FILTER_OPERATORS_AG_GRID: {
  displayKey: string
  displayName: string
  predicate?: (filterValue: number[], cellValue: number) => boolean
  numberOfInputs?: number
}[] = [
  {
    displayKey: filterOperatorValues.EQUALS,
    displayName: 'Is Equal To',
    predicate: ([filterValue], cellValue) => cellValue === filterValue,
    numberOfInputs: 1,
  },
  {
    displayKey: filterOperatorValues.NOT_EQUALS,
    displayName: 'Is Not Equal To',
    predicate: ([filterValue], cellValue) => cellValue !== filterValue,
    numberOfInputs: 1,
  },
  {
    displayKey: filterOperatorValues.GREATER_THAN,
    displayName: 'Is Greater Than',
    predicate: ([filterValue], cellValue) => cellValue > filterValue,
    numberOfInputs: 1,
  },
  {
    displayKey: filterOperatorValues.GREATER_THAN_OR_EQUAL,
    displayName: 'Is Greater Than or Equal',
    predicate: ([filterValue], cellValue) => cellValue >= filterValue,
    numberOfInputs: 1,
  },
  {
    displayKey: filterOperatorValues.LESS_THAN,
    displayName: 'Is Less Than',
    predicate: ([filterValue], cellValue) => cellValue < filterValue,
    numberOfInputs: 1,
  },
  {
    displayKey: filterOperatorValues.LESS_THAN_OR_EQUAL,
    displayName: 'Is Less Than or Equal',
    predicate: ([filterValue], cellValue) => cellValue <= filterValue,
    numberOfInputs: 1,
  },
  {
    displayKey: filterOperatorValues.BETWEEN,
    displayName: 'Is In Range',
    predicate: ([fv1, fv2], cellValue) => cellValue >= fv1 && cellValue <= fv2,
    numberOfInputs: 2,
  },
  {
    displayKey: filterOperatorValues.NOT_BETWEEN,
    displayName: 'Is Not In Range',
    predicate: ([fv1, fv2], cellValue) => cellValue < fv1 || cellValue > fv2,
    numberOfInputs: 2,
  },
  {
    displayKey: filterOperatorValues.IS_NULL,
    displayName: 'Is Null',
    predicate: (_, cellValue) => cellValue === null || cellValue === undefined,
    numberOfInputs: 0,
  },
  {
    displayKey: filterOperatorValues.IS_NOT_NULL,
    displayName: 'Is Not Null',
    predicate: (_, cellValue) => cellValue !== null && cellValue !== undefined,
    numberOfInputs: 0,
  },
]
export const FILTER_OPERATOR_MAP: Record<string, string> = {
  [filterOperatorValues.EQUALS]: filterOperatorValues.IN,
} as const
